module.exports = __webpack_public_path__ + "static/media/sqwad_logo_white.4012c789.svg";